/**
 * Applies the legacy "today" buffer — if a gap starts in the next 30
 * minutes, bump its start to `now + 30min` so candidates can't click a
 * slot that's about to start. Plays on top of minimum-notice rather
 * than replacing it: whichever cutoff is later wins.
 */
export const TODAY_BUFFER_MINUTES = 30;

export function applyTodayBuffer(
  gapStartMs: number,
  nowMs: number,
  bufferMinutes: number = TODAY_BUFFER_MINUTES
): number {
  const cutoffMs = nowMs + bufferMinutes * 60_000;
  return gapStartMs < cutoffMs ? Math.max(gapStartMs, cutoffMs) : gapStartMs;
}
